module.exports = __webpack_public_path__ + "static/img/banner2.baaaaf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page_productcenter/banner2.png
// module id = nflb
// module chunks = 1